var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("controller", {
    staticClass: "relative",
    attrs: { localsearch: _vm.search },
    scopedSlots: _vm._u([
      {
        key: "inputview",
        fn: function(ref) {
          var keydownEvent = ref.keydownEvent
          var keyupEvent = ref.keyupEvent
          var model = ref.model
          var goToSearch = ref.goToSearch
          var activated = ref.activated
          var show = ref.show
          var activeSearch = ref.activeSearch
          return [
            _c(
              "div",
              { staticClass: "relative search-form" },
              [
                _c("a", {
                  staticClass:
                    "circle-btn circle-btn--mini circle-btn--circle svgicon-search",
                  class: { "is-hidden": show },
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return activeSearch($event)
                    }
                  }
                }),
                _c("transition", [
                  show
                    ? _c(
                        "div",
                        {
                          staticClass: "search-input",
                          class: activated
                            ? "appearance_halfcircle"
                            : "appearance_circle"
                        },
                        [
                          _c("input-group", {
                            ref: "search-input",
                            attrs: {
                              type: "search",
                              placeholder: _vm._(
                                "Введіть запит або слово для пошуку "
                              ),
                              autocomplete: "nddddo",
                              autofocus: true,
                              id: "inputsearch"
                            },
                            on: { keydown: keydownEvent, keyup: keyupEvent },
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "search"
                            }
                          }),
                          _c(
                            "a",
                            {
                              staticClass: "search-input__close",
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return activeSearch($event)
                                }
                              }
                            },
                            [_vm._v("×")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ebefb60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebefb60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/View.vue
// module id = 230
// module chunks = 4